import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import DialogTitle from '@mui/material/DialogTitle'
import IconButton from '@mui/material/IconButton'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import rehypeRaw from 'rehype-raw'
import React from 'react'

import ContainedButton from 'shared/components/Buttons/ContainedButton'
import CustomDialog from 'shared/components/CustomDialog'
import { Close } from '@mui/icons-material'

interface Props {
   open: boolean
   message?: string
   title?: string
   handleClose: () => void
}

export default function Modal({ open, handleClose, message, title }: Props) {
   return (
      <CustomDialog
         isLoading={!open}
         open={open}
         onClose={handleClose}
         content={
            <>
               <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  {title}
                  {title === 'Ankieta' && (
                     <IconButton onClick={handleClose} sx={{ '&:hover': { color: 'red' }, mt: -1 }}>
                        <Close />
                     </IconButton>
                  )}
               </DialogTitle>
               <DialogContent
                  sx={{
                     textAlign: 'center',
                     minWidth: 300,
                     whiteSpace: 'pre-wrap',
                  }}
               >
                  <ReactMarkdown rehypePlugins={[rehypeRaw]} remarkPlugins={[remarkGfm]}>
                     {message}
                  </ReactMarkdown>
               </DialogContent>
               <DialogActions>
                  {title !== 'Ankieta' && (
                     <ContainedButton variant="contained" onClick={handleClose}>
                        OK
                     </ContainedButton>
                  )}
               </DialogActions>
            </>
         }
      />
   )
}
